import { useState, useEffect } from 'react'
import { useModal } from 'components/modals/provider'
import Image from 'components/image/image'
import Icon from 'components/icon/icon'
import styles from './input-image.module.scss'
import { cn } from 'utils/helpers'
import useApi from 'utils/api'
import useAppState from 'utils/state'

export default function InputImage({ name, model = 'User', label, required, onChange, value, logo }) {
    const [image, setImage] = useState(value)
    const [initialImage] = useState(value)
    const { showConfirm } = useModal()
    const { postWithToast } = useApi()
    const { showLoader } = useAppState()

    useEffect(() => {
        if (value && typeof value === 'object') {
            const reader = new FileReader()
            reader.onloadend = () => {
                setImage(reader.result)
            }
            reader.readAsDataURL(value)
        }
    }, [value])

    const handeChange = async () => {
        const file = event.target.files[0]
        let fileResult
        if (file.type === 'image/heic') {
            const heic2any = require('heic2any')
            showLoader(true)
            fileResult = await heic2any({ blob: file, toType: 'image/jpeg' })
            showLoader(false)
        } else {
            fileResult = file
        }
        const reader = new FileReader()
        if (fileResult && typeof fileResult === 'object') {
            reader.onloadend = () => {
                setImage(reader.result)
            }
            reader.readAsDataURL(fileResult)
            onChange({ name, value: fileResult })
        }

        // const file = event.target.files[0]
        // const reader = new FileReader()
        // if (file && typeof file === 'object') {
        //     reader.onloadend = () => {
        //         setImage(reader.result)
        //     }
        //     reader.readAsDataURL(file)
        //     onChange(e)
        // }
    }

    const handleDelete = () => {
        if (typeof value === 'string') {
            showConfirm('Ar tikrai norite ištrinti šią nuotrauką?').then(async confirmed => {
                if (confirmed) {
                    const response = await postWithToast('delete-image', { name, model })
                    if (response.status === 200) {
                        setImage(null)
                        onChange({ name, value: null })
                    }
                }
            })
        } else {
            onChange({ name, value: initialImage })
            setImage(initialImage)
        }
    }

    return (
        <div className={styles.input}>
            {value && <Icon icon="x" className={styles.delete} onClick={handleDelete} />}
            <div>
                <div>
                    <div>
                        {image ? (
                            <div className={cn(styles.image, logo && styles.logo)}>
                                <Image src={image} alt="Nuotrauka" layout="fill" objectFit="contain" />
                            </div>
                        ) : (
                            <>
                                <Icon icon="image" />
                                <div className={styles.text}>{label}</div>
                            </>
                        )}
                        <input
                            accept="image/x-png,image/jpeg,image/heic,image/webp"
                            type="file"
                            name={name}
                            onChange={handeChange}
                            required={required}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
